import type { AuthUser } from "../stores/authStore";

/**
 * Decide para onde mandar o usuário logo após abrir a sessão, com base no estado
 * real da conta. A ordem reflete o funil do onboarding da imobiliária:
 *
 *  1. perfil incompleto      → cadastro da imobiliária (CNPJ/endereço)
 *  2. termos não aceitos     → aceite dos termos legais
 *  3. aprovação pendente     → tela de aguardando aprovação do backoffice
 *  4. tudo aprovado          → painel
 *
 * Só uma imobiliária `approved` acessa o portal — esse é o gate exclusivo do agency.
 */
export function nextRouteFor(user: AuthUser): string {
  if (!user.profileCompleted) return "/onboarding/agency-profile";
  if (!user.termsAccepted) return "/onboarding/terms";
  if (user.approvalStatus !== "approved") return "/onboarding/pending";
  return "/dashboard";
}
